<template>
  <div class="video-button">
    <button class="video-button__button" @click="$emit('click')">
      <icon class="video-button__button-icon" name="play"></icon>
    </button>
  </div>
</template>

<script>
export default {
  name: "VideoButton",
};
</script>

<style lang="scss" scoped>
@import "../styles";
</style>
